// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MessageMenu__menu-placeholder-cfb4dd {
  display: flex;
  opacity: 0;
  padding-top: 3px;
  transition: opacity 0.15s ease-in-out;
  align-self: flex-start;
  position: sticky;
  top: 0;
  min-width: 120px;
  margin: 0 8px;
  z-index: 1;
}

.MessageMenu__menu-placeholder-cfb4dd.MessageMenu__opened-c7897a {
  opacity: 1;
}

.MessageMenu__right-f2ea40 {
  justify-content: flex-end;
  padding-inline-end: 4px;
}

.MessageMenu__item-container-cb9f46 {
  align-self: flex-start;
  margin-inline-start: 12px;
  min-width: 32px;
  width: 32px;
  height: 32px;
  padding: 0;
}

:root[dir=rtl] .MessageMenu__replyIcon-fb5d75 {
  transform: scaleX(-1);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/MessageLayout/MessageMenu/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,UAAA;EACA,gBAAA;EACA,qCAAA;EACA,sBAAA;EACA,gBAAA;EACA,MAAA;EACA,gBAAA;EACA,aAAA;EACA,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,yBAAA;EACA,uBAAA;AACF;;AAEA;EACE,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AACF;;AAEA;EACE,qBAAA;AACF","sourcesContent":[".menu-placeholder {\n  display: flex;\n  opacity: 0;\n  padding-top: 3px;\n  transition: opacity 0.15s ease-in-out;\n  align-self: flex-start;\n  position: sticky;\n  top: 0;\n  min-width: 120px;\n  margin: 0 8px;\n  z-index: 1;\n}\n\n.menu-placeholder.opened {\n  opacity: 1;\n}\n\n.right {\n  justify-content: flex-end;\n  padding-inline-end: 4px;\n}\n\n.item-container {\n  align-self: flex-start;\n  margin-inline-start: 12px;\n  min-width: 32px;\n  width: 32px;\n  height: 32px;\n  padding: 0;\n}\n\n:root[dir='rtl'] .replyIcon {\n  transform: scaleX(-1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-placeholder": `MessageMenu__menu-placeholder-cfb4dd`,
	"menuPlaceholder": `MessageMenu__menu-placeholder-cfb4dd`,
	"opened": `MessageMenu__opened-c7897a`,
	"right": `MessageMenu__right-f2ea40`,
	"item-container": `MessageMenu__item-container-cb9f46`,
	"itemContainer": `MessageMenu__item-container-cb9f46`,
	"replyIcon": `MessageMenu__replyIcon-fb5d75`
};
module.exports = ___CSS_LOADER_EXPORT___;
